import type { ReactNode } from "react";
import { Icon, type IconName } from "../Icon";

interface EmptyStateProps {
  icon?: IconName;
  title: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon = "list", title, children, action }: EmptyStateProps) {
  return (
    <div className="empty">
      <Icon name={icon} className="empty-icon" />
      <h3>{title}</h3>
      {children ? <p>{children}</p> : null}
      {action}
    </div>
  );
}
